import React from "react";
import {
  Card,
  CardContent,
} from "@/shared/ui/card"
import { Dialog, DialogContent, DialogTrigger } from "@/shared/ui/dialog"
import { Button } from "@/shared/ui/button"
import AddSubstitute from '@/features/profile/substitutes/AddSubstitute'
import { useTranslation } from "react-i18next";
import { SubstituteEditableRow } from "@/features/profile/substitutes/SubstituteEditableRow"

export const AddButton = ({ 
  label, 
  type, 
  isOpen, 
  setIsOpen, 
  className = "",
  buttonClassName = "" 
}) => (
  <Dialog className={className} open={isOpen} onOpenChange={setIsOpen}>
    <DialogTrigger asChild className={className}>
      <Button className={`w-full ${buttonClassName}`}>
        {label}
      </Button>
    </DialogTrigger>
    <DialogContent className="rounded-3xl px-8 py-4">
      <AddSubstitute type={type} setIsOpen={setIsOpen} title={label}/>
    </DialogContent>
  </Dialog>
);

const EmptyState = ({ items, mode, view }) => {
  const { t } = useTranslation();
  if (items.length > 0) return null;

  const message = mode === "vocabulary" ? t("profile.noVocabulary") : t("profile.noTextModules");
  const className = `p-4 text-center ${view === "mobile" ? "text-sm" : "text-xl"} font-medium text-[#71717A] flex items-center ${view === "mobile" ? "h-96" : "h-48"} justify-center`;

  return <p className={className}>{message}</p>;
};

function SubstituteList({ items, mode, variant }) {
  if (variant === "desktop") {
    return items.map((item, index) => (
      <CardContent
        key={item.id}
        className={`${
          index === items.length - 1 ? "p-4" : "p-4 pb-0"
        }`}
      >
        <SubstituteEditableRow item={item} mode={mode} />
      </CardContent>
    ));
  }

  return items.map((item) => (
    <div key={item.id}>
      <SubstituteEditableRow item={item} mode={mode} />
    </div>
  ));
}

export const FindReplaceDesktop = ({ 
  items = [], 
  mode = "vocabulary"
}) => {
  if (!Array.isArray(items)) {
    return null;
  }

  return (
    <CardContent className="md:block hidden p-0">
      <Card className="rounded-2xl shadow-none border-none">
        <SubstituteList items={items} mode={mode} variant="desktop" />
        <EmptyState items={items} mode={mode} view="desktop" />
      </Card>
    </CardContent>
  );
};

export const FindReplaceMobile = ({ 
  items = [], 
  mode = "vocabulary", 
  isDialogOpen, 
  setIsDialogOpen 
}) => {
  const { t } = useTranslation();
  
  if (!Array.isArray(items)) {
    return null;
  }

  return (
    <CardContent className="md:hidden p-0 border-none">
      <Card className="rounded-2xl shadow-none border-none">
        <CardContent className="py-4 px-0 w-full">
          <div className="w-full">
            <AddButton
              label={mode === "vocabulary" ? t("profile.vocabulary.addButton") : t("profile.textModules.addButton")}
              type={mode === "vocabulary" ? "vocabulary" : "text_module"}
              isOpen={isDialogOpen}
              setIsOpen={setIsDialogOpen}
              className="flex md:hidden w-full px-4" 
              buttonClassName="w-full mb-4" 
            />
          </div>
          <div className="border-b border-slate-200 w-full" />
          <div className="flex flex-col gap-4 mt-4 px-4">
            <SubstituteList items={items} mode={mode} variant="mobile" />
            <EmptyState items={items} mode={mode} view="mobile" />
          </div>
        </CardContent>
      </Card>
    </CardContent>
  );
};
